import { FC } from "react";

import { RadioGroup as RadioGroupBase, Stack } from "@chakra-ui/react";

import { FormFieldLabel, FormMessage, FormBox } from "@components/common";
import useUpdateValue from "@hooks/useUpdateValue";

import { TRadioGroupProps } from "./types";
import mapRadioList from "./utils/mapRadioList";

const RadioGroup: FC<TRadioGroupProps> = ({
  options,
  label,
  message,
  isGrey,
  onChange,
  initialValue,
  inline = false,
  ...commonProps
}) => {
  const [innerValue, setInnerValue] = useUpdateValue(initialValue);

  return (
    <RadioGroupBase
      onChange={(newValue) => {
        setInnerValue(newValue);
        onChange?.(newValue);
      }}
      value={innerValue}
    >
      <FormFieldLabel label={label} />
      <FormBox inline={inline} isGrey={isGrey} spacing="0">
        <FormMessage message={message} isInvalid />
        <Stack direction={inline ? "row" : "column"} spacing="1.25rem">
          {mapRadioList(options, commonProps)}
        </Stack>
      </FormBox>
    </RadioGroupBase>
  );
};

export default RadioGroup;
